define('../app/fukit/configuration/google.analytics.configuration',['require','exports','module','../config','../lib/url.change.tracker'],function(require, exports, module) {
  var config = require('../config');
  require('../lib/url.change.tracker');

  var GoogleAnalyticsConfiguration = {
    radioEvents: {
      'app start': 'onAppStart',
    },

    onAppStart: function() {
      var gaConfig = config.get('google.analytics.*') || {};
      if (gaConfig.enabled) {
        ga('create', gaConfig.trackingId, 'auto');
        ga('require', 'urlChangeTracker');
        ga('send', 'pageview');
      }
    },
  };

  module.exports = GoogleAnalyticsConfiguration;
});

